var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "btn-group flex-shrink-0",
    class: {
      'd-flex': _vm.block
    },
    attrs: {
      "role": "group"
    }
  }, _vm._l(_vm.states, function (state) {
    return _c('button', {
      key: state,
      staticClass: "btn btn-sm",
      class: [_vm.value === state ? 'btn-primary' : 'btn-secondary', {
        'w-100': _vm.block
      }],
      attrs: {
        "type": "button",
        "aria-pressed": _vm.value === state,
        "disabled": _vm.disabled
      },
      on: {
        "click": function ($event) {
          _vm.value !== state && _vm.$emit('input', state);
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.$t(`alarm_notifications.state.${state.toLowerCase()}`)) + " ")]);
  }), 0);

}
var staticRenderFns = []

export { render, staticRenderFns }